<template>
  <b-container fluid>
    <backlink/>
    <h1>Entreprises</h1>

    <AdminTable :config="config" :options="options"></AdminTable>
  </b-container>
</template>

<script>
import AdminTable from "@/components/Global/AdminTable";
import config from "./config";

export default {
  name: "CompanyList",
  components: {
    AdminTable
  },
  data() {
    return {
      config: config
    };
  },
  computed: {
    options: function() {
      return {
        company_type_options: this.$store.getters[
          "company_type/getAll"
        ].selectOptions("id", "name"),
        company_group_options: this.$store.getters[
          "company_group/getAll"
        ].selectOptions("id", "name")
      };
    }
  },
  mounted() {
    this.$store.dispatch("company_type/getAll");
    this.$store.dispatch("company_group/getAll");
  }
};
</script>


// WEBPACK FOOTER //
// src/components/Company/CompanyList.vue